import { joinDataTestId } from "@/constants/data-test-ids.utils.ts";
import { EApplianceEstimateCode } from "@/domains/site/site.types.ts";

const component = "edit-appliance-estimates-modal-form" as const;

export const editApplianceEstimatesModalForm = {
  component,
  heatPumpBrand: joinDataTestId(component, "heat-pump-brand"),
  createHeatPumpBrand: joinDataTestId(component, "create-heat-pump-brand-btn"),
  heatPumpModel: joinDataTestId(component, "heat-pump-model"),
  createHeatPumpModel: joinDataTestId(component, "create-heat-pump-model-btn"),
  heatPumpNotEligibleWarning: joinDataTestId(component, "heat-pump-not-eligible-warning"),
  heatPumpToQualifyInfo: joinDataTestId(component, "heat-pump-to-qualify-info"),
  submitForm: joinDataTestId(component, "submit-form-btn"),
  cancelForm: joinDataTestId(component, "cancel-form-btn"),
  applianceEstimateField: (code: EApplianceEstimateCode) => joinDataTestId(component, "appliance-estimate-field", code),
};
